export const totalCalory = (quantity, cal) => {
  if (quantity) {
    return parseFloat(quantity) * (parseFloat(cal) || 0);
  } else {
    return 0;
  }
};

export const totalProtein = (quantity, protien_cal) => {
  if (quantity) {
    return parseFloat(quantity) * (parseFloat(protien_cal) || 0);
  } else {
    return 0;
  }
};

export const totalFat = (quantity, fat_cal) => {
  if (quantity) {
    return parseFloat(quantity) * (parseFloat(fat_cal) || 0);
  } else {
    return 0;
  }
};

export const totalCarbs = (quantity, carbs_cal) => {
  if (quantity) {
    return parseFloat(quantity) * (parseFloat(carbs_cal) || 0);
  } else {
    return 0;
  }
};
